export default "__VITE_ASSET__DkUiUecF__"